import React, { useRef, useEffect, useState } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import DeleteDevicePic from "../../../../assets/images/deletedSuccessfully.png";
import { useDispatch, useSelector } from "react-redux";
import { deleteDevice } from "../../AxiosRtk/DeviceDetail";
import { setShowMessage } from "../../AxiosRtk/successMessage";

const DeleteDevice = ({ showModal, closeModal, getLangTranslation }) => {
  const dispatch = useDispatch();
  const modalRef = useRef();
  const { selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);
  
  const handleDelete = async () => {
    try {
      const payload = {
        deviceId: selectedDeviceData?.ID,
        kidId: selectedKidId,
      };
      const { data } = await deleteDevice(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        setTimeout(() => {
          window.location.href = "/dashboard"
        },3000);
      }
    } catch (error) {
      closeModal();
      console.log(error);
    }
  };

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation(
                "DEVICE_DETAIL_BUTTON_DELTE_DEVICE",
                "DELETE DEVICE"
              )}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => closeModal()}
            ></button>
          </div>
          <div className="modal-body">
            <img
              className="d-block mx-auto mt-6"
              src={DeleteDevicePic}
              alt=""
            />
            <h6 className="mt-6 mb-9 text-center text-blue-900">
              {getLangTranslation(
                "DEVICE_DETAIL_DELETE_DEVICE",
                "Do you really want to delete this device?"
              )}
            </h6>
            <div className="grid gap-3">
              <button
                className="btn btn-outline-primary g-col-6"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CANCEL", "Cancel")}
                </span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleDelete()}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("DELETE_CHILD_DELETE", "Delete")}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteDevice;
